"use client";

import type { Dispatch, SetStateAction } from "react";

interface StatusFilterButtonsProps {
  statusFilter: string[];
  setStatusFilter: Dispatch<SetStateAction<string[]>>;
  statusOptions: Array<{ status: string; count: number }>;
  activeCount: number;
  dismissedCount: number;
  hideDismissed: boolean;
  setHideDismissed: Dispatch<SetStateAction<boolean>>;
}

export function StatusFilterButtons({
  statusFilter,
  setStatusFilter,
  statusOptions,
  activeCount,
  dismissedCount,
  hideDismissed,
  setHideDismissed,
}: StatusFilterButtonsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={() => setStatusFilter([])}
        className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
          statusFilter.length === 0
            ? "bg-black text-white"
            : "bg-zinc-100 text-zinc-600 hover:bg-zinc-200"
        }`}
      >
        All ({activeCount})
      </button>
      {statusOptions.map(({ status, count }) => (
        <button
          key={status}
          type="button"
          onClick={() =>
            setStatusFilter((prev) =>
              prev.includes(status)
                ? prev.filter((s) => s !== status)
                : [...prev, status],
            )
          }
          className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            statusFilter.includes(status)
              ? "bg-black text-white"
              : "bg-zinc-100 text-zinc-600 hover:bg-zinc-200"
          }`}
        >
          {status} ({count})
        </button>
      ))}
      {dismissedCount > 0 && (
        <button
          type="button"
          onClick={() => setHideDismissed((v) => !v)}
          className="ml-auto rounded-full px-3 py-1 text-xs font-medium bg-zinc-100 text-zinc-500 hover:bg-zinc-200 transition-colors"
        >
          {dismissedCount} dismissed — {hideDismissed ? "Show" : "Hide"}
        </button>
      )}
    </div>
  );
}
